import { Companion_getInstance1tv6fqjnytc8u as Companion_getInstance } from '../type/GraphQLBoolean.mjs';
import {
  Builder320ghmibyd2no as Builder,
  Builder3t31vflw4km89 as Builder_0,
  CompiledVariablecaz6ndkw7us2 as CompiledVariable,
} from '../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CompiledGraphQL.mjs';
import { Companion_getInstanceoymipm3rjnhd as Companion_getInstance_0 } from '../type/Mutation.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GrantDiscordAccessMutationSelectionsClass;
function GrantDiscordAccessMutationSelections() {
  if (GrantDiscordAccessMutationSelectionsClass === VOID) {
    class $ {
      constructor() {
        GrantDiscordAccessMutationSelections_instance = this;
        this.z6i_1 = listOf((new (Builder())('grantDiscordAccess', Companion_getInstance().p6r_1)).f46(listOf((new (Builder_0())(Companion_getInstance_0().w6g_1)).q46(new (CompiledVariable())('input')).v39())).v39());
      }
    }
    initMetadataForObject($, 'GrantDiscordAccessMutationSelections');
    GrantDiscordAccessMutationSelectionsClass = $;
  }
  return GrantDiscordAccessMutationSelectionsClass;
}
var GrantDiscordAccessMutationSelections_instance;
function GrantDiscordAccessMutationSelections_getInstance() {
  if (GrantDiscordAccessMutationSelections_instance === VOID)
    new (GrantDiscordAccessMutationSelections())();
  return GrantDiscordAccessMutationSelections_instance;
}
//region block: exports
export {
  GrantDiscordAccessMutationSelections_getInstance as GrantDiscordAccessMutationSelections_getInstanceopm2ykg5ack9,
};
//endregion

//# sourceMappingURL=GrantDiscordAccessMutationSelections.mjs.map
